'use strict';

var _require = require('../mindash');

var extend = _require.extend;

function getHandlers(store) {
  return extend({}, store.handlers, store.constructor.handlers);
}

module.exports = getHandlers;


/*****************
 ** WEBPACK FOOTER
 ** ./~/marty-lib/modules/store/getHandlers.js
 ** module id = 238
 ** module chunks = 0
 **/